import React from 'react'

import { Arabic_Image,English_Image } from '../../assets/images';
import { useStateContext } from '../../context/ContextProvider'
import SmallButton from './SmallButton';
const LanguageToggle = () => {

    const { setLang, currentLang } = useStateContext();
  
    const handleLangChange = () => {

      if (currentLang === 'ar') {
        setLang('en');
      } else if (currentLang === 'en') {
        setLang('ar');
      }

    }
  
  return (
    <SmallButton onClick={handleLangChange} >
      <img src={currentLang === 'ar' ? English_Image : Arabic_Image} alt="Language" className="h-8 w-8 rounded-full m-1 p-1"/></SmallButton>
   
  )
}

export default LanguageToggle